export default class Provider {
  providerId?: number | null;
  firstName?: string | null;
  lastName?: string | null;

  public constructor(params: Provider = {} as Provider) {
    let { providerId = 0, firstName = "", lastName = "" } = params;
    this.providerId = providerId;
    this.firstName = firstName;
    this.lastName = lastName;
  }
}
